<template>
  <modal
    v-if="showModal"
    @close="closeModal"
    class="shoppable-modal"
    :wide="true"
    :fit="true"
  >
    <template #header>
      <div class="title">Browse Catalogs</div>
      <button
        class="modal-close tb-btn tb-btn-text sm low-em"
        data-test="shoppableModal-close"
        @click="closeModal"
        data-entity="producer-shoppable-closeFanaticsModal"
      >
        <span class="fas fa-times" />
      </button>
    </template>

    <div class="tabs-component flex h-full flex-col flex-grow">
      <div class="tabs-header flex">
        <button
          class="tab-title"
          v-for="tab in tabs"
          :key="tab.value"
          :class="{ active: tab.value === activeTab.value }"
          :data-test="`shoppableModal-${tab.title}`"
          @click="activeTab = tab"
        >
          {{ tab.title }}
        </button>
      </div>

      <div class="tab-body min-h-0 flex-grow">
        <keep-alive>
          <component
            :is="activeTab.component"
            data-test="shoppableModal-fanaticsCatalog"
            @selected="handleSelectedItems(activeTab.value, $event)"
          />
        </keep-alive>
      </div>
    </div>

    <template #footer>
      <div class="flex items-center justify-end gap-4">
        <p
          v-if="selectedCollection"
          class="mb-0 flex-grow self-center text-left leading-none"
        >
          Saving to collection: {{ selectedCollectionData.name }}
        </p>
        <p
          v-if="totalSelectedItems > 0"
          class="mb-0 self-center text-primary leading-none"
        >{{ totalSelectedItems }} item(s) saved</p>
        <button
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-shoppable-done"
          data-test="shoppableModal-doneButton"
          @click="done"
        >
          Done
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import Modal from '@/js/components/modal/Modal.vue';
import FanaticsCatalog from '@/js/components/shoppable/FanaticsCatalog.vue';
import AmazonCatalog from '@/js/components/shoppable/AmazonCatalog.vue';

export default {
  name: 'ShoppableModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    Modal,
    FanaticsCatalog,
    AmazonCatalog,
  },

  data() {
    return {
      selectedItemsByTab: {},
      activeTab: null, // default set in created
    };
  },

  computed: {
    ...mapState('shoppable', [
      'selectedCollection',
    ]),
    ...mapGetters('shoppable', [
      'selectedCollectionData',
    ]),

    ...mapGetters([
      'hasShoppableAmazon',
    ]),

    showModal: {
      get() {
        return this.value;
      },
      set(v) {
        if (!v) {
          this.$emit('close', v);
        }
      },
    },

    tabs() {
      const tabsList = [
        {
          title: 'Fanatics',
          value: 'fanatics',
          component: FanaticsCatalog,
        },
      ];

      if (this.hasShoppableAmazon) {
        tabsList.push({
          title: 'Amazon',
          value: 'amazon',
          component: AmazonCatalog,
        });
      }

      return tabsList;
    },

    totalSelectedItems() {
      return this.selectedItemsByTab[this.activeTab.value] || 0;
    },
  },

  created() {
    // TODO: should this be the default each time the modal is opened or should it remember the last tab?
    // this way will allow it to remember the last tab
    // use watch to reset activeTab to first tab when modal is closed
    [this.activeTab] = this.tabs;
  },

  methods: {
    closeModal() {
      this.showModal = false;
    },
    done() {
      this.selectedItemsByTab = [];
      this.closeModal();
    },
    handleSelectedItems(tab, items) {
      this.$set(this.selectedItemsByTab, tab, items);
    },
  },
};
</script>

<style lang="scss">
.shoppable-modal {
  // specificity overrides
  .modal-body {
    min-height: 21.875rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .filter-bar {
    padding: 0;
  }

  .tabs-component {
    min-height: 0;
  }

  .tab-body {
    min-height: 0;
    overflow: hidden;
  }
}
</style>
